import { AgentThreadMessage } from "@/store/chat.types";

/**
 * 判断是否为用户消息
 */
export function isUserMessage(message: AgentThreadMessage): boolean {
  return message.type === "user";
}

export function isAssistantTextMessage(message: AgentThreadMessage): boolean {
  return message.type === "assistant" && !message.content?.func_name;
}

export function isToolRequestMessage(message: AgentThreadMessage): boolean {
  return message.type === "assistant" && !!message.content?.func_name;
}

export function isToolResponseMessage(message: AgentThreadMessage): boolean {
  return message.type === "function";
}

export function isToolMessage(message: AgentThreadMessage): boolean {
  return isToolRequestMessage(message) || isToolResponseMessage(message);
}

export function isAssistMessage(message: AgentThreadMessage): boolean {
  return isAssistantTextMessage(message) || isToolMessage(message) || isRtcMessage(message);
}

/**
 * 判断是否为 RTC (Remote Tool Call) 消息 - 用户手动触发的工具调用
 * RTC 请求类型是 "rtc"，响应类型是 "function"
 */
export function isRtcRequestMessage(message: AgentThreadMessage): boolean {
  return (message.type as string) === "rtc" && !!message.content?.func_name;
}

export function isRtcMessage(message: AgentThreadMessage): boolean {
  return isRtcRequestMessage(message);
}

/**
 * 判断是否为 Checkpoint 消息
 */
export function isCheckpointMessage(message: AgentThreadMessage): boolean {
  return (message.type as string) === "checkpoint";
}

/**
 * 从 checkpoint 消息中提取 commit_hash
 */
export function getCheckpointCommitHash(message: AgentThreadMessage): string | undefined {
  if (!isCheckpointMessage(message)) {
    return undefined;
  }
  return message.commitHash;
}
